import { FigureAxisData, isFigureAxisData } from "./FigureAxisData";
import { FigureGroupData, isFigureGroupData } from "./FigureGroupData";
import { FigureLegendData, isFigureLegendData } from "./FigureLegendData";
import { FigureReferenceLinesData, isFigureReferenceLinesData } from "./FigureReferenceLinesData";
import { FigureRegressionLineData, isFigureRegressionLineData } from "./FigureRegressionLineData";
import { FigureVarData, isFigureVarData } from "./FigureVarData";

export interface FigureData extends Record<
  string,
  | string
  | FigureAxisData[]
  | FigureGroupData[]
  | FigureLegendData[]
  | FigureReferenceLinesData[]
  | FigureRegressionLineData[]
  | FigureVarData[]
> {
  id: string;
  figureType: string;
  legendType: string;
  properties: FigureVarData[];
  figureTypeProperties: FigureVarData[];
  axes: FigureAxisData[];
  dataGroups: FigureGroupData[];
  legend: FigureLegendData[];
  referenceLines: FigureReferenceLinesData[];
  regressionLines: FigureRegressionLineData[];
}

/**
 * Type guard to check if an object is a FigureData
 *
 * @param obj - The object to check
 * @returns - true if the object is a FigureData
 */
export const isFigureData = (obj: unknown): obj is FigureData => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureData;
  if (typeof chkObj.id !== "string") {
    return false;
  }
  if (typeof chkObj.figureType !== "string") {
    return false;
  }
  if (typeof chkObj.legendType !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((option) => !isFigureVarData(option))) {
    return false;
  }
  if (!Array.isArray(chkObj.figureTypeProperties)) {
    return false;
  }
  if (chkObj.figureTypeProperties.some((option) => !isFigureVarData(option))) {
    return false;
  }
  if (!Array.isArray(chkObj.axes)) {
    return false;
  }
  if (chkObj.axes.some((axis) => !isFigureAxisData(axis))) {
    return false;
  }
  if (!Array.isArray(chkObj.dataGroups)) {
    return false;
  }
  if (chkObj.dataGroups.some((group) => !isFigureGroupData(group))) {
    return false;
  }
  if (!Array.isArray(chkObj.legend)) {
    return false;
  }
  if (chkObj.legend.some((item) => !isFigureLegendData(item))) {
    return false;
  }
  if (!Array.isArray(chkObj.referenceLines)) {
    return false;
  }
  if (chkObj.referenceLines.some((item) => !isFigureReferenceLinesData(item))) {
    return false;
  }
  if (!Array.isArray(chkObj.regressionLines)) {
    return false;
  }
  if (chkObj.regressionLines.some((line) => !isFigureRegressionLineData(line))) {
    return false;
  }
  return true;
};
